export default "<div class=\"editor\" contenteditable=\"true\" #dataContainer title=\"\"  (keyup)=\"change()\">\r\n</div>\r\n";